<template>
  <div class="home-page">
    <!-- 全屏轮播图 -->
    <section class="hero-section">
      <el-carousel :height="carouselHeight" :interval="5000" arrow="always" class="all-carousel">
        <el-carousel-item v-for="(slide, index) in bannerData" :key="index">
          <div class="carousel-content" :style="{ backgroundImage: `url(${slide.imageUrl})` }"
            @click="navigateTo(slide.path)">
            <div class="overlay"></div>
            <div class="carousel-caption"></div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <div class="home-content">
      <!-- 新闻中心模块 -->
      <section class="business-areas">
        <div class="page-container">
          <div class="business-title-container">
            <div class="business-title">
              <div class="business-title-left"></div>
              <div class="business-title-right"></div>
              新闻中心
            </div>
          </div>
          <!-- 修改后的代码部分 -->
          <div class="business-grid">
            <!-- 新闻中心导航栏 -->
            <div class="grid-container">
              <div class="grid-container-box littleHand">医院动态</div>
              <div class="grid-container-more littleHand" @click="navigateTo('/newsCenter/hospitalNews')">
                更多
              </div>
            </div>
            <!-- 图文一体化 -->
            <div class="grid-container-content-top">
              <div v-for="(area, index) in businessAreas" :key="index" class="business-card">
                <!-- 左边轮播图部分 -->
                <div class="carousel-container" v-if="index == 0">
                  <!-- 轮播图（上半部分） -->
                  <section class="hero-section">
                    <el-carousel ref="newsCarousel" :interval="2000" arrow="always" @change="onNewsCarouselChange">
                      <el-carousel-item v-for="(item, itemIndex) in newsContentList" :key="itemIndex">
                        <div class="carousel-content" :style="{
                          backgroundImage: `url(${item.imageUrl})`,
                        }"></div>
                      </el-carousel-item>
                    </el-carousel>
                  </section>

                  <!-- business-hover（下半部分） -->
                  <div class="business-hover" @click="currentClick(currentNewsId)">
                    <span class="ellipsis">
                      {{ currentNewsTitle }}
                    </span>
                    <div class="business-hover-img">
                      <img style="vertical-align: middle" src="./../assets/images/pageImage/newsTo.png" alt="右箭头" />
                    </div>
                  </div>
                </div>

                <!-- 右边文字介绍 -->
                <div v-else-if="index == 1" class="info-container">
                  <div class="business-card">
                    <!-- 滚动容器 -->
                    <div class="scrolling-container">
                      <div class="scrolling-content">
                        <!-- 复制一份内容以实现无缝滚动 -->
                        <div v-for="(item, itemIndex) in newsContentList" :key="itemIndex" class="info-container-box"
                          @mouseenter="handleNewsHover(itemIndex)" @click="
                            handleNewsClick('/newsCenter/hospitalNews', item.id)
                            ">
                          <!-- 左边日历 -->
                          <div class="info-container-img">
                            <p style="font-size: 18px; font-weight: 600">
                              {{ extractPublishTime(item.publishTime).day }}
                            </p>
                            <p style="font-size: 11px; font-weight: 500">
                              {{
                                extractPublishTime(item.publishTime).yearMonth
                              }}
                            </p>
                          </div>
                          <!-- 右边介绍 -->
                          <div class="info-container-content">
                            <p class="news-title ellipsis">
                              {{ item.title }}
                            </p>
                            <p class="news-subtitle ellipsis">
                              {{ item.subTitle }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 新闻总览 -->
            <div class="grid-container-content-bottom">
              <div v-for="(area, index) in businessBottomAreas" :key="index" class="business-card fixed-width-card">
                <div>
                  <div class="grid-container">
                    <div class="grid-container-box">
                      {{ area.categoryName }}
                    </div>
                    <div class="grid-container-more-two littleHand" @click="navigateTo(area.link)">
                      MORE+
                    </div>
                  </div>
                  <div class="grid-container-textarea">
                    <p v-for="(item, itemIndex) in area.items" :key="itemIndex" @click="allNewsClick(item, area.link)"
                      class="littleHand">
                      <span class="point">·</span>
                    <div class="textarea-title-body">
                      <div class="textarea-title">{{ item.title }}</div>
                      <div class="textarea-sub-title">{{ item.subTitle }}</div>
                    </div>
                    <span class="textarea-date">{{
                      truncateTimestamp(item.publishTime)
                    }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 医院概况 -->
      <section class="news-section">
        <div class="page-container">
          <div class="business-title-container">
            <div class="business-title">
              <div class="business-title-left"></div>
              <div class="business-title-right"></div>
              医院概况
            </div>
          </div>
          <div class="page-container-hospital">
            <div class="page-container-hospital-img" :style="{ backgroundImage: `url(${hospitalGkForm.imageUrl})` }">
              <!-- <img :src="hospitalGkForm.imageUrl" alt="" /> -->
            </div>
            <div class="page-container-hospital-content">
              <div class="grid-container-Overview">
                <div v-html="truncatedHospitalContent"></div>
              </div>
              <div class="grid-container-more littleHand" @click="navigateTo('/hospitalIntroduction/overview')">
                更多
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 科室导航 -->
      <section class="video-section">
        <div class="page-container">
          <div class="business-title-container">
            <div class="business-title">
              <div class="business-title-left"></div>
              <div class="business-title-right"></div>
              科室导航
            </div>
          </div>

          <!-- 院区切换标签 -->
          <div class="hospital-tabs">
            <div v-for="(tab, index) in hospitalTabs" :key="index" class="tab-item"
              :class="{ active: activeHospitalIndex === index }" @click="switchHospital(index)">
              {{ tab.name }}
            </div>
          </div>

          <div class="page-container-hospital">
            <!-- 左侧科室图片 -->
            <div class="page-container-hospital-img">
              <div class="page-container-hospital-img-div">
                {{ currentDepartment.name || "科室" }}
              </div>
              <img :src="currentDepartment.photoUrl || defaultDepartmentImage" class="department-image"
                :alt="currentDepartment.name || '默认科室图片'" />
            </div>

            <!-- 右侧科室列表 -->
            <div class="page-container-hospital-content">
              <div class="department-categories">
                <span v-for="(category, catIndex) in departmentCategories" :key="catIndex" class="category-item"
                  :class="{ active: activeCategoryIndex === catIndex }" @click="switchCategory(catIndex)">
                  {{ category }}
                </span>
              </div>

              <div class="department-list">
                <div v-for="(dept, deptIndex) in currentDepartments" :key="deptIndex" class="department-item"
                  :class="{ active: activeDepartmentIndex === deptIndex }" @mouseenter="hoverDepartment(deptIndex)"
                  @click="
                    selectDepartment(
                      '/departmentIntroduction/administrative',
                      dept.id
                    )
                    ">
                  <div class="department-content">
                    <span>{{ dept.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="department-lists">
            <div v-for="(dept, deptIndex) in currentDepartments" :key="deptIndex" class="department-item"
              :class="{ active: activeDepartmentIndex === deptIndex }" @mouseenter="hoverDepartment(deptIndex)" @click="
                selectDepartment(
                  '/departmentIntroduction/administrative',
                  dept.id
                )
                ">
              <div class="department-content">
                <span>{{ dept.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 名医介绍 -->
      <section class="join-section">
        <div class="page-container">
          <div class="business-title-container">
            <div class="business-title">
              <div class="business-title-left"></div>
              <div class="business-title-right"></div>
              名医介绍
            </div>
          </div>
          <div class="famousDoctor" >
            <!-- 左箭头  -->
            <div class="arrow" @click="handleFamousDoctorNextPage('prev')"
              v-if="famousCarouselSlides.length > doctorPageSize && doctorCurrentPage > 0">
              <img class="leftArrowImg" src="./../assets/images/pageImage/leftArrow.png" alt="上一页" />
            </div>

            <!-- 轮播内容区域， 鼠标悬停和离开监听放在这里。放在上一层若点击左箭头或右箭头，会触发两次 -->
            <div class="famous-container" @mouseenter="stopFamousDoctorCarousel" @mouseleave="startFamousDoctorCarousel">
              <div v-for="(doctor, index) in visibleDoctors" :key="index" class="famous-item" @click="
                famousDoctorChange(
                  '/expertIntroduction/specialist',
                  doctor.id
                )">
                <div class="doctor-card">
                  <img :src="doctor.photoUrl" alt="医生照片" class="doctor-image" />
                  <div class="doctor-info">
                    <div class="doctor-name">
                      {{ doctor.name }} | {{ doctor.doctorTitle }}
                    </div>
                    <!-- <div class="doctor-title"></div> -->
                    <div class="doctor-department">
                      {{ doctor.departmentName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 右箭头 -->
            <div class="arrow" @click="handleFamousDoctorNextPage('next')" v-if="famousCarouselSlides.length > doctorPageSize && doctorCurrentPage < totalPages - 1
            ">
              <img class="rightArrowImg" src="./../assets/images/pageImage/leftArrow.png" alt="下一页" />
            </div>
            <!-- <span>{{ doctorCurrentPage }}</span> -->
          </div>
        </div>
      </section>

      <!-- 底部默认图片 -->
      <section class="stock-section">
        <div class="page-container">
          <div class="grid-container-content">
            <div v-for="(area, index) in businessAreas" :key="index" class="business-card"
              @click="navigateTo(area.link)">
              <img class="footer-img" :src="area.imageUrl" alt="" />
              <div class="business-hover">
                <span>{{ area.title }} <span v-if="area.subTitle">：</span>{{ area.subTitle }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  computed,
  provide,
  nextTick,
  onBeforeUnmount,
} from "vue";
// import { CarouselInstance } from "element-plus";
import { useRouter } from "vue-router";
// import { getHotNews } from "@/api/news";
import { formatDate, getSummary } from "@/utils/helper";
import CountTo from "@/components/CountTo.vue";
import {
  articleList,
  departmentList,
  doctorList,
  bannerList,
} from "@/api/homePage.js";
import { artcleSingle } from "@/api/hospital.js";
import { menuList } from "@/api/menu";

export default {
  name: "HomeView",
  components: {
    CountTo,
  },
  setup() {
    const activeName = ref("first");
    const router = useRouter();
    const newsList = ref([]);
    const isLoading = ref(false);
    const statisticsData = ref([]);
    const statisticsLoading = ref(false);
    const menuTabList = ref([]);
    const articleForm = ref({}); //文章数据
    const hospitalGkForm = ref({});
    const newsContentList = ref([]);
    const currentNewsIndex = ref(3);
    const currentNewsTitle = ref("");
    const currentNewsId = ref("");
    const bannerData = ref([]);
    const newsCarousel = ref(); // 添加轮播图引用
    const isHovering = ref(false); // 添加悬停状态
    const autoPlayInterval = ref(5000); // 保存原始自动播放间隔
    const defaultDepartmentImage = require("@/assets/images/pageImage/department1.png");

    // 格式化当前时间
    const currentTime = computed(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    });

    const doctorCurrentPage = ref(0);
    // const doctorPageSize = ref(6); // 每页显示5位医生
    const doctorPageSize = computed(() => {
      // 定义断点：768px为PC/移动端分界（可根据需求调整）
      // 移动端6个，PC端5个
      return window.innerWidth <= 768 ? 6 : 5;
    });
    const famousCarouselSlides = ref([]); // 响应的数据集
    const carouselTimer = ref(null); // 轮播定时器
    const carouselInterval = ref(5000); // 自动轮播间隔（毫秒）
    // const isCarouselPaused = ref(false);
 
    // 计算当前页显示的医生
    const visibleDoctors = computed(() => {
      if (!famousCarouselSlides.value || famousCarouselSlides.value.length === 0
      ) {
        return [];
      }

      const start = doctorCurrentPage.value * doctorPageSize.value;
      // 确保不会超出数组边界
      // const end = Math.min(start + doctorPageSize.value, famousCarouselSlides.value.length);
      const end = start + doctorPageSize.value;
      return famousCarouselSlides.value.slice(start, end);
    });
    // 总页数
    const totalPages = computed(() =>
      Math.ceil(famousCarouselSlides.value.length / doctorPageSize.value)
    );

    // 上一页
    const prevPage = () => {
      if (doctorCurrentPage.value > 0) {
        doctorCurrentPage.value--;
      }
    };

    // 下一页
    const nextPage = () => {
      const maxPage = Math.ceil(famousCarouselSlides.value.length / doctorPageSize.value) - 1;
      if (doctorCurrentPage.value < maxPage) {
        doctorCurrentPage.value++;
      }
    };

    // 名医介绍点击事件
    const famousDoctorChange = (path, id) => {
      // console.log(path,id)
      navigateTo(path, id);
    };

    // 恢复名医轮播
    const startFamousDoctorCarousel = () => {
      // 先清除已有定时器，避免重复创建
      stopFamousDoctorCarousel();

      // console.log("in startFamousDoctorCarousel 恢复名医轮播")
      // 只有当数据大于每页显示数量时才启动轮播
      if (famousCarouselSlides.value.length > doctorPageSize.value) {
        carouselTimer.value = setInterval(() => {
          autoFamousDoctorNextPage();
        }, carouselInterval.value);
      }
    };

    // 暂停名医轮播
    const stopFamousDoctorCarousel = () => {
      // console.log("in stopFamousDoctorCarousel 暂停名医轮播")
      if (carouselTimer.value) {
        clearInterval(carouselTimer.value);
        carouselTimer.value = null;
      }
    };
    // 自动翻页函数
    const autoFamousDoctorNextPage = () => {
      // 如果是最后一页，回到第一页
      if (doctorCurrentPage.value >= (totalPages.value - 1)) {
        doctorCurrentPage.value = 0;
      } else {
        doctorCurrentPage.value++;
      }
    };

    // 名医轮播，箭头点击事件处理
    const handleFamousDoctorNextPage = (type) => {
      // 立即暂停轮播
      stopFamousDoctorCarousel();
      // 执行翻页逻辑
      if (type === 'prev') {
        prevPage();
      } else {
        nextPage();
      }
      // 延迟恢复轮播（可选，提升体验）
      setTimeout(() => {
        startFamousDoctorCarousel();
      }, carouselInterval.value * 2);
    };

    // const truncatedHospitalContent = computed(() => {
    //   const content = hospitalGkForm.value.content || "";
    //   return content.length > 250 ? content.substring(0, 250) + "..." : content;
    // });

    const truncatedHospitalContent = computed(() => {
      const content = hospitalGkForm.value.content || "";
      // 1. 先把 &nbsp; 换成空格，统一处理
      const cleaned = content.replace(/&nbsp;/g, " ");
      // 2. 匹配 <p>...</p>（含属性、换行、嵌套标签）
      const pReg = /<p[^>]*>([\s\S]*?)<\/p>/gi;
      const arr = [...cleaned.matchAll(pReg)];
      // 3. 过滤：只要内部纯文本里 **不出现** &nbsp;（或空格串）
      const valid = arr
        .map(([, inner]) => {
          // 去掉内部所有标签，只留纯文本
          const text = inner.replace(/<[^>]+>/g, "").trim();
          // 如果纯文本里还有 &nbsp; 或全是空格，就扔掉
          if (!text || text.includes("\u00A0") || /^[\s]*$/.test(text))
            return "";
          return `<p>${inner}</p>`;
        })
        .join("");
      // 4. 截断 250 字符（含标签长度）
      return valid.length > 200 ? valid.slice(0, 200) + "..." : valid;
    });

    const activeHospitalIndex = ref(0);
    const activeCategoryIndex = ref(0);
    const activeDepartmentIndex = ref(0);
    // 科室数据（按院区分类）
    const departmentsData = ref([]);
    const hospitalTabs = ref([]);
    // });
    // 科室分类
    // 科室分类
    const departmentCategories = computed(() => {
      if (!hospitalTabs.value || hospitalTabs.value.length === 0) return [];
      const currentHospitalTab = hospitalTabs.value[activeHospitalIndex.value];
      if (!currentHospitalTab) return [];
      const hospitalId = currentHospitalTab.id;
      if (!departmentsData.value || departmentsData.value.length === 0)
        return [];
      const currentHospital = departmentsData.value.find(
        (item) => item.id === hospitalId
      );
      if (!currentHospital || !currentHospital.departmentList) return [];
      return currentHospital.departmentList.map((dept) => dept.name);
    });

    // 当前显示的科室列表（根据分类过滤）
    const currentDepartments = computed(() => {
      if (!hospitalTabs.value || hospitalTabs.value.length === 0) return [];
      const currentHospitalTab = hospitalTabs.value[activeHospitalIndex.value];
      if (!currentHospitalTab) return [];
      const hospitalId = currentHospitalTab.id;
      if (!departmentsData.value || departmentsData.value.length === 0)
        return [];
      const currentHospital = departmentsData.value.find(
        (item) => item.id === hospitalId
      );
      if (!currentHospital || !currentHospital.departmentList) return [];

      // 获取当前选中的分类
      if (
        !departmentCategories.value ||
        departmentCategories.value.length === 0
      )
        return [];
      const currentCategory =
        departmentCategories.value[activeCategoryIndex.value];
      const selectedDept = currentHospital.departmentList.find(
        (dept) => dept.name === currentCategory
      );
      return selectedDept?.children || [];
    });

    // 当前选中的科室详情
    const currentDepartment = computed(() => {
      const dept = currentDepartments.value[activeDepartmentIndex.value];
      return (
        dept || {
          name: "",
          photoUrl: defaultDepartmentImage,
          description: "",
        }
      );
    });
    // 切换院区
    const switchHospital = (index) => {
      activeHospitalIndex.value = index;
      activeCategoryIndex.value = 0;
      activeDepartmentIndex.value = 0;
    };

    // 切换科室分类
    const switchCategory = (index) => {
      activeCategoryIndex.value = index;
      activeDepartmentIndex.value = 0;
    };
    // 鼠标悬停科室
    const hoverDepartment = (index) => {
      activeDepartmentIndex.value = index;
    };
    // 选择具体科室
    const selectDepartment = (path, id) => {
      console.log(path, id, "123");
      localStorage.setItem("hosType", "科室");
      navigateTo(path, id);
    };

    // 轮播图数据
    const carouselSlides = [
      {
        title: "让更多人过上更有品质的生活",
        subtitle: "开拓新价值",
        buttonText: "了解更多",
        buttonLink: "/about",
        image: require("@/assets/images/pageImage/carouselOne.png"),
      },
      {
        title: "以创新技术赋能企业数字化转型",
        subtitle: "技术引领发展",
        buttonText: "我们的业务",
        buttonLink: "/boxs",
        image: require("@/assets/images/pageImage/carouselOne.png"),
      },
      {
        title: "构建可持续发展的数字化未来",
        subtitle: "共创美好未来",
        buttonText: "加入我们",
        buttonLink: "/recruits",
        image: require("@/assets/images/pageImage/carouselOne.png"),
      },
    ];

    // 新闻中心轮播图数据
    const newsCarouselSlides = [
      {
        title: "让更多人过上更有品质的生活",
        subtitle: "开拓新价值",
        buttonText: "了解更多",
        buttonLink: "/about",
        image: require("@/assets/images/pageImage/carouselOne.png"),
      },
      {
        title: "以创新技术赋能企业数字化转型",
        subtitle: "技术引领发展",
        buttonText: "我们的业务",
        buttonLink: "/boxs",
        image: require("@/assets/images/pageImage/carouselOne.png"),
      },
      {
        title: "构建可持续发展的数字化未来",
        subtitle: "共创美好未来",
        buttonText: "加入我们",
        buttonLink: "/recruits",
        image: require("@/assets/images/pageImage/carouselOne.png"),
      },
    ];

    // 业务领域数据
    const businessAreas = ref([
      {
        link: "/healthServices/identification",
        reMark: "中国体质辨别：快来看看你是什么体质吧？",
        title: "主标题",
        subTitle: "副标题",
        imageUrl: "",
        image: require("@/assets/images/pageImage/oneImg.jpg"),
      },
      {
        link: "/healthServices/teaDrinks",
        reMark: "中医养生服务：特色茶饮",
        title: "主标题",
        subTitle: "副标题",
        imageUrl: "",
        image: require("@/assets/images/pageImage/twoImg.jpg"),
      },
    ]);
    // 修改businessBottomAreas为动态数据
    const businessBottomAreas = computed(() => {
      return [
        {
          categoryName: "媒体聚焦",
          categoryCode: "news_mt",
          link: "/newsCenter/mediaFocus",
          items: articleForm.value.news_mt?.slice(0, 6) || [],
        },
        {
          categoryName: "党务公开",
          categoryCode: "news_dw",
          link: "/newsCenter/disclosure",
          items: articleForm.value.news_dw?.slice(0, 6) || [],
        },
        {
          categoryName: "招投标公告",
          categoryCode: "notice_ztb",
          link: "/notice/bidding",
          items: articleForm.value.notice_ztb?.slice(0, 6) || [],
        },
      ];
    });

    const fetchNewsContent = () => {
      if (articleForm.value && articleForm.value.news_dt) {
        // 只取前4条数据
        newsContentList.value = articleForm.value.news_dt
          .slice(0, 6)
          .map((item) => ({
            title: item.title,
            subTitle: item.subTitle,
            content: item.content,
            publishTime: item.publishTime,
            id: item.id,
            imageUrl: item.imageUrl, // 使用业务区域的图片作为后备
          }));

        // 初始化当前显示的新闻标题（取第一条）
        if (newsContentList.value.length > 0) {
          currentNewsTitle.value = newsContentList.value[0].title;
          currentNewsId.value = newsContentList.value[0].id;
        }
      }
    };

    const extractPublishTime = (publishTime) => {
      if (!publishTime) return { day: "", yearMonth: "" };

      const datePart = publishTime.split(" ")[0]; // "2025-08-12"
      const [year, month, day] = datePart.split("-"); // ["2025", "08", "12"]

      return {
        day: day, // "12"
        yearMonth: `${year}-${month}`, // "2025-08"
      };
    };
    const currentMenu = ref();
    const detailId = ref();
    provide("currentMenu", currentMenu);
    provide("detailId", detailId);
    // 页面导航
    const navigateTo = (path, id) => {
      detailId.value = undefined;
      if (path) {
        // 更新当前菜单
        const findMenuData = (menus, path) => {
          for (const menu of menus) {
            if (menu.path === path) return menu;
            if (menu.children) {
              const found = findMenuData(menu.children, path);
              if (found) return found;
            }
          }
          return;
        };
        detailId.value = id;
        currentMenu.value = findMenuData(menuTabList.value, path);

        if (currentMenu.value) {
          localStorage.setItem(
            "currentMenu",
            JSON.stringify(currentMenu.value)
          );
        }
        if (detailId.value) {
          localStorage.setItem("detailId", detailId.value);
        } else {
          localStorage.setItem("detailId", "空");
        }

        router.push(path);
      }
    };
    const truncateTimestamp = (timestamp) => {
      return String(timestamp).slice(0, 10); // 转为字符串并截取前10位
    };

    // 查看新闻详情
    const viewNewsDetail = (id) => {
      router.push(`/news/${id}`);
    };

    // 处理新闻悬停事件
    const handleNewsHover = (index) => {
      // 使用 Element Plus 提供的 setActiveItem 方法
      if (
        newsCarousel.value &&
        typeof newsCarousel.value.setActiveItem === "function"
      ) {
        newsCarousel.value.setActiveItem(index);
      }

      // 更新当前新闻标题
      const actualIndex = index % newsContentList.value.length;
      currentNewsId.value = newsContentList.value[actualIndex].id;
      currentNewsTitle.value =
        newsContentList.value[actualIndex].title.length > 25
          ? newsContentList.value[actualIndex].title.substring(0, 25) + "..."
          : newsContentList.value[actualIndex].title;
    };

    const handleNewsClick = (path, id) => {
      console.log(path, id, "123");
      navigateTo(path, id);
    };
    const allNewsClick = (item, link) => {
      navigateTo(link, item.id);
    };
    const currentClick = (data) => {
      navigateTo("/newsCenter/hospitalNews", data);
    };

    const fentchArtcle = async (pageList) => {
      const param = {
        pageList,
      };
      const res = await articleList(param);
      if (res.data.code == 200) {
        articleForm.value = res.data.data;
        hospitalGkForm.value = res.data.data["hospital_gk"];
        fetchNewsContent();
      }
      // console.log(arr, 'arr123')
    };
    // 当前轮播索引 → 标题
    const onNewsCarouselChange = (index) => {
      if (newsContentList.value[index]) {
        const title = newsContentList.value[index].title;
        currentNewsTitle.value =
          title.length > 25 ? title.slice(0, 25) + "..." : title;
      }
    };
    const fentchDepartment = async () => {
      try {
        const res = await departmentList();
        if (res.data.code == 200) {
          departmentsData.value = res.data.data;

          if (res.data.data && res.data.data.length > 0) {
            hospitalTabs.value = res.data.data.map((item) => ({
              name: item.name,
              id: item.id,
            }));

            // 初始化时设置默认选中的院区和分类
            if (hospitalTabs.value.length > 0) {
              activeHospitalIndex.value = 0;
              if (departmentsData.value[0]?.departmentList?.length > 0) {
                activeCategoryIndex.value = 0;
              }
            }
          }
        }
      } catch (error) {
        console.error("获取科室数据失败:", error);
      }
    };
    const carouselHeight = computed(() =>
      window.innerWidth <= 768 ? "100%" : "100%"
    );
    const fentchDoctor = async () => {
      const res = await doctorList();
      if (res.data.code == 200) {
        // 确保赋值的是数组
        famousCarouselSlides.value = Array.isArray(res.data.data)
          ? res.data.data
          : [];
      }
    };
    const fenthBanner = async () => {
      try {
        const res = await bannerList();
        if (res.data.code == 200) {
          bannerData.value = res.data.data;
        }
      } catch (error) {
        console.error("获取科室数据失败:", error);
      }
    };
    const fentchArtcleSingle = async () => {
      const param = {
        categoryCode: "knowledge_bs",
      };
      const params = {
        categoryCode: "knowledge_cy",
      };
      const bsRes = await artcleSingle(param);
      const cyRes = await artcleSingle(params);
      if (bsRes.data.code == 200 && cyRes.data.code == 200) {
        businessAreas.value[0].title = bsRes.data.data.title;
        businessAreas.value[0].subTitle = bsRes.data.data.subTitle;
        businessAreas.value[0].imageUrl = require("@/assets/images/pageImage/oneImg.jpg");
        // businessAreas.value[0].imageUrl = bsRes.data.data.imageUrl;
        businessAreas.value[1].title = cyRes.data.data.title;
        businessAreas.value[1].subTitle = cyRes.data.data.subTitle;
        businessAreas.value[1].imageUrl = require("@/assets/images/pageImage/twoImg.jpg");
        // businessAreas.value[1].imageUrl = cyRes.data.data.imageUrl;
      }
    };
    // 获取菜单数据
    const fetchMenuList = async () => {
      try {
        const res = await menuList();
        if (res.data) {
          // 过滤掉不需要显示的菜单项（如果需要）
          menuTabList.value = res.data.data || res.data;
          // localStorage.getItem('menuTabList', menuTabList)
          localStorage.setItem(
            "menuTabList",
            JSON.stringify(menuTabList.value)
          );
        }
      } catch (error) {
        console.error("获取菜单失败:", error);
        // 可以设置默认菜单或显示错误
      }
    };
    // 第一个定义（保留这个）
    const findMenuItems = (menuItems, targetNames, result = []) => {
      if (!menuItems || !Array.isArray(menuItems)) {
        return result;
      }

      for (const item of menuItems) {
        if (targetNames.includes(item.menuName) && item.code) {
          result.push({
            pageIndex: 1,
            pageSize: 10,
            categoryCode: item.code,
          });
        }

        if (item.children && item.children.length > 0) {
          findMenuItems(item.children, targetNames, result);
        }
      }
      return result;
    };

    // 预加载轮播图图片
    const preloadBannerImages = () => {
      if (bannerData.value && bannerData.value.length > 0) {
        bannerData.value.forEach((banner) => {
          if (banner.imageUrl) {
            const img = new Image();
            img.src = banner.imageUrl;
          }
        });
      }
    };

    // 修改 onMounted 中的调用方式
    onMounted(async () => {
      // 先尝试从本地存储加载菜单数据
      const menuData = localStorage.getItem("menuTabList");
      if (menuData) {
        try {
          menuTabList.value = JSON.parse(menuData);
        } catch (e) {
          menuTabList.value = [];
        }
      }
      // 预加载轮播图图片
      preloadBannerImages();
      if (newsContentList.value.length) {
        const firstTitle = newsContentList.value[0].title;
        currentNewsTitle.value =
          firstTitle.length > 30 ? firstTitle.slice(0, 30) + "..." : firstTitle;
      }

      // 确保 menuTabList.value 是一个数组
      if (!Array.isArray(menuTabList.value)) {
        menuTabList.value = [];
      }

      const targetMenuNames = [
        "医院动态",
        "媒体聚焦",
        "党务公开",
        "招投标公告",
        "医院概况",
      ];

      // 先获取菜单数据
      await fetchMenuList();

      // 只有当 menuTabList.value 有数据时才调用 findMenuItems
      const pageList =
        menuTabList.value.length > 0
          ? findMenuItems(menuTabList.value, targetMenuNames)
          : [];

      // 并行执行其他数据获取
      await Promise.all([
        fenthBanner(),
        fentchArtcle(pageList),
        fentchDepartment(),
        fentchDoctor(),
        fentchArtcleSingle(),
      ]);

      // 组件挂载后启动自动轮播
      // console.log("in onMounted")
      startFamousDoctorCarousel();

    });

    onBeforeUnmount(() => {
      // 组件销毁前清除定时器，防止内存泄漏
      // console.log("in onBeforeUnmount")
      stopFamousDoctorCarousel();
    });

    return {
      carouselSlides,
      businessAreas,
      businessBottomAreas,
      newsCarouselSlides,
      famousCarouselSlides,
      newsContentList,
      hospitalTabs,
      activeHospitalIndex,
      activeCategoryIndex,
      activeDepartmentIndex,
      departmentCategories,
      departmentsData,
      currentDepartments,
      currentDepartment,
      hospitalGkForm,
      truncatedHospitalContent,
      currentNewsTitle,
      currentNewsId,
      bannerData,
      newsCarousel,
      handleNewsHover,
      onNewsCarouselChange,
      switchHospital,
      switchCategory,
      selectDepartment,
      famousDoctorChange,
      newsList,
      isLoading,
      currentTime,
      formatDate,
      getSummary,
      navigateTo,
      viewNewsDetail,
      statisticsData,
      statisticsLoading,
      visibleDoctors,
      prevPage,
      nextPage,
      truncateTimestamp,
      extractPublishTime,
      hospitalTabs,
      activeHospitalIndex,
      activeCategoryIndex,
      activeDepartmentIndex,
      departmentCategories,
      departmentsData,
      currentDepartments,
      currentDepartment,
      defaultDepartmentImage,
      switchHospital,
      switchCategory,
      hoverDepartment,
      selectDepartment,
      handleNewsClick,
      allNewsClick,
      currentClick,
      doctorCurrentPage,
      totalPages,
      currentNewsIndex,
      carouselHeight,
      doctorPageSize,
      startFamousDoctorCarousel,
      stopFamousDoctorCarousel,
      handleFamousDoctorNextPage
    };
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  .hero-section {
    // margin-top: 130px;
    margin-top: 0;
    position: relative;
    cursor: pointer;

    .el-carousel {
      height: 700px;

      @media (max-width: 768px) {
        height: 180px;
      }

      .el-carousel__container {
        position: relative;
        height: 100% !important;
      }

      ::deep(.el-carousel__container) {
        position: relative;
        height: 100% !important;
      }
    }

    .el-carousel__container {
      position: relative;
      height: 100% !important;
    }

    ::deep(.el-carousel__container) {
      position: relative;
      height: 100% !important;
    }

    .carousel-content {
      height: 100%;
      // background-position: center;
      background-size: 100% 100%;
      position: relative;

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        // background-color: rgba(0, 0, 0, 0.4);
      }

      .carousel-caption {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: white;
        width: 80%;
        max-width: 800px;
        z-index: 2;

        .slide-subtitle {
          font-size: 26px;
          font-weight: 500;
          margin-bottom: 15px;
          letter-spacing: 1px;
        }

        .slide-title {
          font-size: 46px;
          font-weight: 700;
          margin-bottom: 30px;
          line-height: 1.2;
        }

        .slide-button {
          padding: 12px 30px;
          font-size: 16px;
          font-weight: 500;
          background-color: #163c7d;
          border-color: #163c7d;

          &:hover {
            background-color: darken(#163c7d, 10%);
            border-color: darken(#163c7d, 10%);
          }
        }
      }
    }
  }

  .business-areas {
    padding: 30px 0;

    .business-title {
      margin: 30px 0;
      position: relative;
      display: inline-block;
      font-size: 54px;
      font-family: STXingkai;
      color: #a65226;
      padding: 0 10px;
      text-align: center;

      @media (max-width: 768px) {
        margin: 15px 0;
        font-size: 26px;
        padding: 0 5px;
      }

      .business-title-left {
        position: absolute;
        top: 0;
        left: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/leftTop.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          width: 30px;
          height: 30px;
        }
      }

      .business-title-right {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/rightBottom.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          width: 30px;
          height: 30px;
        }
      }
    }

    .business-grid {
      .grid-container {
        height: 100%;
        width: 100%;
        font-size: 26px;
        display: flex;
        justify-content: space-between;
        background-color: #f5f5f5;

        @media (max-width: 768px) {
          font-size: 20px;
        }

        .grid-container-box {
          background-color: #fff;
          width: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #a65226;
          border-top: 1.5px solid #a65226;
          letter-spacing: 1px;

          @media (max-width: 768px) {
            width: 120px;
            font-size: 18px;
          }
        }

        .grid-container-more {
          margin: 5px 20px 5px 5px;
          padding: 5px 10px;
          width: 110px;
          text-align: center;
          color: #666666;
          background: url("./../assets/images/pageImage/allMore.png") no-repeat;
          background-size: 100% 100%;

          @media (max-width: 768px) {
            margin: 5px 10px 5px 5px;
            padding: 0 5px;
            width: 90px;
          }
        }

        .grid-container-more-two {
          padding: 5px 10px;
          width: 110px;
          text-align: center;
          color: #666666;

          @media (max-width: 768px) {
            // width: 120px;
            font-size: 22px;
          }
        }
      }

      .grid-container-content-top {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        padding: 20px 0;
        align-items: stretch;

        @media (max-width: 768px) {
          // grid-template-columns: repeat(2, 1fr);
        }

        .business-card {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-width: 0;
          /* ① 关键：允许网格项压缩到比内容更小 */
          overflow: hidden;

          @media (max-width: 768px) {
            min-width: 0;
            /* ① 关键：允许网格项压缩到比内容更小 */
            overflow: hidden;
            width: 100%;
          }
        }
      }

      .carousel-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;

        .hero-section {
          .el-carousel {
            height: 240px;

            @media (max-width: 768px) {
              height: 200px;
            }

            :deep(.el-carousel__container) {
              height: 100%;

              .el-carousel__item {
                height: 100%;

                .carousel-content {
                  height: 100%;
                  width: 100%;
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                }
              }
            }
          }
        }

        .business-hover {
          display: flex;
          align-items: center;
          background: url("./../assets/images/pageImage/newsDiv.png") no-repeat;
          background-size: cover;
          color: white;
          padding: 10px 15px;
          cursor: pointer;
          height: 80px;
          font-size: 24px;

          @media (max-width: 768px) {
            padding: 5px 10px;
            height: 40px;
            font-size: 15px;
          }

          .ellipsis {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .business-hover-img {
            width: 30px;
            height: 30px;
            margin-left: 10px;
            display: flex;
            align-items: center;
            justify-content: center;

            @media (max-width: 768px) {
              width: 15px;
              height: 15px;
              margin-left: 5px;
            }

            img {
              width: 30px;
              height: 30px;

              @media (max-width: 768px) {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }

      .info-container {
        height: 100%;
        overflow: hidden;
        position: relative;

        .business-card {
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .scrolling-container {
          flex: 1;
          overflow: hidden;
          position: relative;
          height: 100%; // 确保容器有明确高度

          .scrolling-content {
            display: flex;
            flex-direction: column;
            position: absolute;
            width: 100%;
            height: 100%; // 改为自动高度（或 100% 也可）
            // gap: 5px; // 可选：项之间的间距

            // 关键修改：让子项平分空间
            .info-container-box {
              height: calc(100% / 6); // 平分 3 等份
              cursor: pointer;
            }

            &:hover {
              animation-play-state: paused;
            }
          }
        }

        .info-container-box {
          display: flex;
          // padding: 10px 0;
          border-bottom: 1px solid #eee;

          .info-container-img {
            flex: 0 0 55px;
            /* 固定宽度 */
            text-align: center;
            margin-right: 10px;
            background: url("./../assets/images/pageImage/newsImg.png") no-repeat;
            background-size: contain;
            display: flex;
            flex-direction: column;
            justify-content: center;

            p {
              color: #a65226;
              margin: 0;
            }
          }

          .info-container-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            min-width: 0;
            /* 关键：防止flex项目溢出 */

            .news-title {
              color: #333;
              letter-spacing: 1.5px;
              font-size: 24px;
              font-weight: 500;
              margin: 0 0 10px 0;
              line-height: 1.2;
            }

            .news-subtitle {
              font-size: 19px;
              color: #666;
              margin: 0;
              line-height: 1.2;
            }

            .ellipsis {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

      @keyframes scrollUp {
        0% {
          transform: translateY(0);
        }

        50% {
          transform: translateY(-50%);
        }

        100% {
          transform: translateY(-100%);
        }
      }

      .grid-container-content-bottom {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        /* 关键修改 */
        gap: 30px;

        .business-card {
          /* 确保内容不会撑开卡片 */
          min-width: 0;
          width: 100%;

          .grid-container-textarea {
            p {
              display: flex;

              .textarea-title-body {
                flex: 1;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                // white-space: nowrap;
              }

              .textarea-title {
                flex: 1;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                letter-spacing: 1px;
              }

              .textarea-sub-title {
                flex: 1;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                letter-spacing: 1px;
              }

              .textarea-date {
                flex-shrink: 0;
                margin-left: 10px;
              }
            }
          }
        }

        @media (max-width: 1200px) {
          grid-template-columns: repeat(2, minmax(0, 1fr));

          .business-card:last-child {
            grid-column: span 2;
            max-width: calc(50% - 15px);
            margin: 0 auto;
          }
        }

        @media (max-width: 768px) {
          grid-template-columns: minmax(0, 1fr);

          .business-card:last-child {
            grid-column: span 1;
            max-width: 100%;
          }
        }
      }

      .grid-container-textarea {
        p {
          text-align: left;
          display: flex;
          height: 100%;
          width: 100%;
          margin-bottom: 0 !important;
          padding: 8px 0;
          border-bottom: 1px solid #d3d3d3;

          .point {
            margin: 0 5px 0 0;
            font-weight: 600;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .textarea-title {
            font-size: 24px;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #333;

            @media (max-width: 768px) {
              font-size: 18px;
            }
          }

          .textarea-sub-title {
            font-size: 16px;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #333;

            @media (max-width: 768px) {
              font-size: 14px;
            }
          }

          .textarea-date {
            margin-left: 10px;
            width: 25%;
            font-size: 19px;
            white-space: nowrap;
            display: flex;
            justify-content: center;
            align-items: center;

            @media (max-width: 768px) {
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .business-grid {
      .grid-container-content-top {
        grid-template-columns: 1fr !important;
      }

      .info-container-box {
        padding: 8px 0 !important;
        min-height: 70px !important;

        .info-container-img {
          flex: 0 0 60px !important;
          margin-right: 10px !important;
        }

        .info-container-content {
          .news-title {
            font-size: 20px !important;
          }

          .news-subtitle {
            font-size: 16px !important;
          }
        }
      }
    }
  }

  .news-section {
    padding: 20px 0;

    .business-title {
      margin: 30px 0;
      position: relative;
      display: inline-block;
      font-size: 54px;
      font-family: STXingkai;
      color: #a65226;
      padding: 0 10px;
      text-align: center;

      @media (max-width: 768px) {
        margin: 15px 0;
        font-size: 26px;
        padding: 0 5px;
      }

      .business-title-left {
        position: absolute;
        top: 0;
        left: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/leftTop.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          width: 30px;
          height: 30px;
        }
      }

      .business-title-right {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/rightBottom.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          width: 30px;
          height: 30px;
        }
      }
    }

    .page-container-hospital {
      display: flex;
      justify-content: space-between;
      // height: 100%;
      width: 100%;

      @media (max-width: 768px) {
        display: block;
      }

      .page-container-hospital-img {
        background: url("./../assets/images/pageImage/carouselOne.png") no-repeat;
        background-size: 100% 100%;
        min-height: 250px;
        width: 30%;

        @media (max-width: 768px) {
          width: 100%;
        }
      }

      .page-container-hospital-content {
        width: 68%;

        @media (max-width: 768px) {
          width: 100%;
        }
      }
    }

    .grid-container-Overview {
      font-size: 18px;
      color: #333;
      text-indent: 2em;
      letter-spacing: 2px;

      :deep(img) {
        display: none;
      }

      :deep(p) {
        font-size: 24px;

        @media (max-width: 768px) {
          font-size: 18px;
        }
      }
    }

    .grid-container-more {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 3px;
      margin: 5px 0;
      padding: 2px 5px;
      width: 70px;
      text-align: center;
      color: #5b0f13;
      // background-color: #F5F5F5;
      background: url("./../assets/images/pageImage/brownDiv.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .video-section {
    padding: 20px 0;

    .hospital-tabs {
      display: flex;
      margin-bottom: 30px;
      border-bottom: 1px solid #eee;

      .tab-item {
        padding: 10px 20px;
        font-size: 30px;
        color: #666;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;

        @media (max-width: 768px) {
          font-size: 25px;
        }

        &:hover {
          color: #a65226;
        }

        &.active {
          color: #a65226;
          font-weight: bold;

          &::after {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 50%;
            transform: translateX(-50%);
            width: 80%;
            height: 3px;
            background-color: #a65226;
            border-radius: 3px;
          }
        }
      }
    }

    .business-title {
      margin: 30px 0;
      position: relative;
      display: inline-block;
      font-size: 54px;
      font-family: STXingkai;
      color: #a65226;
      padding: 0 10px;
      text-align: center;

      @media (max-width: 768px) {
        margin: 15px 0;
        font-size: 28px;
        padding: 0 5px;
      }

      .business-title-left {
        position: absolute;
        top: 0;
        left: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/leftTop.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          width: 30px;
          height: 30px;
        }
      }

      .business-title-right {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/rightBottom.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          height: 30px;
          width: 30px;
        }
      }
    }

    .page-container-hospital {
      display: flex;
      justify-content: space-between;
      width: 100%;
      min-height: 500px;
      gap: 20px;

      @media (max-width: 768px) {
        min-height: 300px;
      }

      .page-container-hospital-img {
        width: 35%;
        position: relative;
        overflow: hidden;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f5f5;

        @media (max-width: 768px) {
          width: 75%;
        }

        .department-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.3s;
        }

        .page-container-hospital-img-div {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 15px;
          text-align: center;
          color: #fff;
          font-size: 20px;
          font-weight: bold;
          background: url("./../assets/images/pageImage/trantDiv.png");
          background-size: cover;
          z-index: 1;
        }
      }

      .page-container-hospital-content {
        width: 65%;
        display: flex;
        flex-direction: column;

        @media (max-width: 768px) {
          width: 23%;
        }

        .department-categories {
          display: flex;
          flex-wrap: wrap;
          gap: 30px; // 保持原有的间距
          margin-bottom: 20px;
          padding-bottom: 15px;

          .category-item {
            padding: 8px 15px;
            cursor: pointer;
            font-size: 30px;
            position: relative; // 为伪元素定位

            @media (max-width: 768px) {
              font-size: 23px;
            }

            &:hover {
              color: #a65226;
            }

            &.active {
              color: #a65226;
            }

            // 添加间隔点（除了最后一个元素）
            &:not(:last-child)::after {
              content: "·";
              position: absolute;
              left: -10px; // 调整位置
              top: 50%;
              transform: translateY(-50%);
              color: black; // 与文字颜色一致
              font-weight: 600;
            }
          }
        }

        .department-list {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 30px 30px;
          // flex: 1;

          .department-item {
            padding: 0;
            text-align: center;
            cursor: pointer;
            // transition: all 0.3s;
            display: flex;
            align-items: center;
            justify-content: center;

            .department-content {
              display: flex;
              flex-direction: column;
              align-items: center;
              padding-top: 12% !important;
              // justify-content: center;
              width: 100%;
              height: 80px;
              padding: 10px;
              background: url("./../assets/images/pageImage/whiteDiv.png") no-repeat;
              background-size: contain;

              span {
                font-size: 1.1rem;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 100%;

                @media (max-width: 768px) {
                  font-size: 1rem;
                }
              }
            }

            // &:hover {
            //   transform: translateY(-3px);
            // }

            &.active {
              .department-content {
                color: #fff;
                font-weight: bold;
                background: url("./../assets/images/pageImage/activeDiv.png") no-repeat;
                background-size: contain;

                span {
                  color: #fff;
                }
              }
            }
          }

          // @media (max-width: 1200px) {
          //   grid-template-columns: repeat(4, 1fr);
          // }

          @media (max-width: 768px) {
            // grid-template-columns: repeat(3, 1fr);
            display: none;
          }
        }
      }
    }

    .department-lists {
      display: none;

      @media (max-width: 768px) {
        margin-top: 30px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 0 20px;
        // flex: 1;

        .department-item {
          padding: 0;
          text-align: center;
          cursor: pointer;
          // transition: all 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;

          .department-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 12% !important;
            // justify-content: center;
            width: 100%;
            height: 80px;
            padding: 10px;
            background: url("./../assets/images/pageImage/whiteDiv.png") no-repeat;
            background-size: contain;

            span {
              font-size: 1.1rem;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;

              @media (max-width: 768px) {
                font-size: 1rem;
              }
            }
          }

          // &:hover {
          //   transform: translateY(-3px);
          // }

          &.active {
            .department-content {
              color: #fff;
              font-weight: bold;
              background: url("./../assets/images/pageImage/activeDiv.png") no-repeat;
              background-size: contain;

              span {
                color: #fff;
              }
            }
          }
        }

        // @media (max-width: 1200px) {
        //   grid-template-columns: repeat(4, 1fr);
        // }
      }
    }
  }

  .join-section {
    padding: 20px 0;

    .business-title {
      margin: 30px 0;
      position: relative;
      display: inline-block;
      font-size: 54px;
      font-family: STXingkai;
      color: #a65226;
      padding: 0 10px;
      text-align: center;

      @media (max-width: 768px) {
        margin: 15px 0;
        font-size: 26px;
        padding: 0 5px;
      }

      .business-title-left {
        position: absolute;
        top: 0;
        left: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/leftTop.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          height: 30px;
          width: 30px;
        }
      }

      .business-title-right {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 60px;
        height: 60px;
        background: url("./../assets/images/pageImage/rightBottom.png") no-repeat;
        background-size: 100% 100%;

        @media (max-width: 768px) {
          height: 30px;
          width: 30px;
        }
      }
    }

    .famousDoctor {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;

      .arrow {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        .leftArrowImg {
          height: 40px;
          width: 30px;
          cursor: pointer;

          @media (max-width: 768px) {
            height: 20px;
            width: 15px;
          }
        }

        .rightArrowImg {
          height: 40px;
          width: 30px;
          transform: rotate(180deg);
          cursor: pointer;

          @media (max-width: 768px) {
            height: 20px;
            width: 15px;
          }
        }
      }

      .famous-container {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 15px;
        // min-height: 300px;
      }

      .famous-item {
        display: flex;
        justify-content: center;
        cursor: pointer;
      }

      .doctor-card {
        width: 100%;
        max-height: 350px;
        padding: 20px;
        // background: white;
        background: url("./../assets/images/pageImage/doctorDiv.png");
        background-size: 100% 100%;
        // border-radius: 8px;
        overflow: hidden;
        transition: transform 0.3s ease;

        @media (max-width: 768px) {
          padding: 10px;
          max-height: 220px;
        }

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        }
      }

      .doctor-image {
        width: 100%;
        height: 75%;
        object-fit: contain;

        @media (max-width: 768px) {
          height: 50%;
        }
      }

      .doctor-info {
        padding: 5px 0;
        text-align: center;

        .doctor-name {
          font-size: 20px;
          font-weight: 500;
          color: #333;
          margin-bottom: 5px;

          @media (max-width: 768px) {
            width: 100%;
            font-size: 15px;
            overflow: hidden;
            /* 超出隐藏 */
            text-overflow: ellipsis;
            /* 省略号 */
          }
        }

        .doctor-title {
          font-size: 21px;
          color: #666;
          margin-bottom: 8px;

          @media (max-width: 768px) {
            font-size: 15px;
          }
        }

        .doctor-department {
          font-size: 21px;
          color: #a65226;
          font-weight: 500;

          @media (max-width: 768px) {
            font-size: 15px;
          }
        }
      }
    }

    @media (max-width: 768px) {
      .famous-container {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
  }

  .stock-section {
    //padding: 40px 0;

    .business-card {
      text-align: center;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      cursor: pointer;

      .footer-img {
        height: 300px;
        width: 100%;

        @media (max-width: 768px) {
          height: 200px;
        }
      }

      .business-icon {
        margin-bottom: 20px;

        i {
          font-size: 46px;
          color: #163c7d;
        }
      }

      h3 {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 15px;
      }

      p {
        font-size: 15px;
        color: #666;
        line-height: 1.6;
        margin-bottom: 20px;
      }

      .business-hover {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: url("./../assets/images/pageImage/newsDiv.png") no-repeat;
        background-size: 100% 100%;
        color: white;
        padding: 10px 0;
        font-size: 23px;
        font-weight: 500;

        @media (max-width: 768px) {
          font-size: 18px;
        }

        span {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
        }
      }
    }

    .grid-container-content {
      padding: 40px 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }

    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .statistics-section {
    background-color: #f5f7fa;
    padding: 80px 0;

    .statistics-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      margin-top: 50px;

      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }

      .statistic-item {
        background-color: #fff;
        border-radius: 8px;
        padding: 30px;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s, box-shadow 0.3s;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .statistic-icon {
          font-size: 38px;
          color: #409eff;
          margin-bottom: 20px;
        }

        .statistic-number {
          font-size: 34px;
          font-weight: 700;
          color: #303133;
          margin-bottom: 10px;

          .statistic-unit {
            font-size: 20px;
            margin-left: 5px;
          }
        }

        .statistic-title {
          font-size: 16px;
          color: #606266;
        }
      }
    }
  }
}

.home-content {
  background: url("./../assets/images/pageImage/bg.png");
  background-size: 100% 100%;
}

.littleHand {
  cursor: pointer;
}

/* 自定义指示器按钮 */
:deep(.el-carousel__button) {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  /* 圆形效果 */
  background-color: rgba(255, 255, 255, 0.5);
  /* 非激活状态颜色 */
  transition: all 0.3s;
}

/* 激活状态样式 */
:deep(.el-carousel__indicator.is-active .el-carousel__button) {
  width: 12px;
  background-color: #fff;
  /* 激活状态颜色 */
}

.brownColor {
  color: #a65226;
}

.allBrownDiv {
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #fff;
  background: url("./../assets/images/pageImage/activeDiv.png") no-repeat !important;
  background-size: 100% 100% !important;
}
</style>
